import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { SCREEN_ID_UTILITY_SETUP_VERIFY_PHONE } from 'client/constants/screenIds';

import { hasRoleRenter } from 'common/utility/userRoles';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import branch from 'client/core/branch';
import UtilityActivationActions from 'client/actions/UtilityActivation';

import SrUtilitySetupPage from 'client/components/SrUtilitySetup/SrUtilitySetupPage';
import SrUtilitySetupVerifyPhone from 'client/components/SrUtilitySetup/SrUtilitySetupVerifyPhone';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_SETUP_VERIFY_PHONE)
@withScrollToTop
@branch(({ match }) => ({
  utilityActivation: ['utilityActivations', 'byAddressId', match.params.addressId],
  utilityUser: ['utilityUser'],
}))
class UtilitySetupVerifyPhonePage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Setup | Verify Phone',
  });

  static fetchData(match, inject) {
    const addressId = parseInt(match.params.addressId, 10);

    if (isNaN(addressId)) {
      return;
    }

    return Promise.all([
      UtilityActivationActions.getByAddressId(inject, {
        addressId,
      }),
    ]);
  }

  render() {
    const { utilityActivation, utilityUser } = this.props;

    if (utilityUser?.id && hasRoleRenter(utilityUser?.roles || [])) {
      return <Redirect to="/utility-setup/session" />;
    }

    if (!utilityActivation) {
      return null;
    }

    return (
      <SrUtilitySetupPage
        addressDisplay={utilityActivation.address.display}
        logoUrl={utilityActivation.partner.logoUrl}
        backButtonText="Back"
        backButtonUrl={`/utility-setup/${utilityActivation.partner.slug}`}
      >
        <SrUtilitySetupVerifyPhone
          utilityUser={utilityActivation?.user || utilityUser || {}}
          utilityActivation={utilityActivation}
        />
      </SrUtilitySetupPage>
    );
  }
}

UtilitySetupVerifyPhonePage.displayName = 'UtilitySetupVerifyPhonePage';

export default UtilitySetupVerifyPhonePage;
